module.exports = __webpack_public_path__ + "img/CallCenter.823bca8d.png";